<template>
	<div>
		<div class="container">
		<!-- <footer-s></footer-s> -->
        <loginHeader></loginHeader>
		<div class="about">			
			<img src="../../assets/img/book-a.jpg" class="about-sign" />
			<div class="register">
				<div class="register-form">
					<h1>免费注册</h1>
					<div class="register-form-box">
						<ul>
							<li>
								<label>公司全称</label>
								<input  class="rfb-input" v-model="regData.CompanyName" type="text" placeholder="分公司或分部，请注明" maxlength="100"/>
                              
							</li>

							<li>
								<label>您的姓名</label>
								<input  class="rfb-input" type="text" v-model="regData.ContactMan" maxlength="50" />
							</li>

							<li>
								<label>联系电话</label>
								<input  class="rfb-input" v-model="regData.Phone" type="text" maxlength="15"  />
							</li>

							<li>
								<label>联系邮箱</label>
								<input  class="rfb-input"  v-model="regData.Email" type="text" placeholder="请填写正确的邮箱以便接收帐号密码" maxlength="50" />
							</li>

							<li >
								<label>公司地址</label>
								<select class="rfb-select" v-model="regData.CountryID" @change="selectProvince" >
									<option value="">国家/地区</option>
                    				<option value="0001">中国大陆</option>

                    				<option v-for="(value, key) in country" :value="key" v-if="key!='0001'">{{value}}</option>
								</select>

								<select class="rfb-select"  v-model="regData.ProvinceID"  @change="selectCity">
									<option value="">城市</option>
                    				<option v-for="(value, key) in province"  :value="key">{{value}}</option>
									 
								</select>

								<select class="rfb-select"  v-model="regData.CityID"  @change="selectTown">
									<option value="">地区</option>
                    				<option v-for="(value, key) in city" :value="key">{{value}}</option>
								</select>
							</li>

							<li>
								<label>详细地址</label>
								<input class="rfb-input"  type="text" placeholder="请填写最详细的地址" v-model="regData.Address"  maxlength="100" />
							</li>

							<li>
								<label class="rfb-label">验证码</label>
								<input class="rfb-check-code"    type="text" placeholder="验证码" maxlength="4"  v-model="regData.CaptchaCode "/>
							
                                <img class="rfb-check-code-img"  @click="getCode()" :src="codeUrl" name="img_Code" alt="点击刷新验证码" style="cursor: pointer; margin-bottom: 3px;"  />
							</li>

						</ul>
						<div>
							<label id="lblError" class="error-box lblError" style="position: absolute;"></label>
							<input type="button" value="提交申请" class="rfb-submit" @click="submit"/>
						</div>
						<div>
							<label class="rfb-check">
								<input type="checkbox"  :value="prototcol" @click="prototcol=!prototcol" />已阅读并同意
							</label>
							<a id="UserURP" @click="isInfoShwo=!isInfoShwo">用户注册协议</a>
							<div id="UserURPInfo" v-show="isInfoShwo">
                                <textarea   style="height:300px;width:874px" tamaxlength="10000" >
1.订房易服务条款的确认和订房易的所有权与运作权归深圳市港捷旅国际旅行社（以下简称"港捷旅"）所有。本服务条款具有法律约束力。一旦您点选"注册"并通过注册程序，即表示您自愿接受本协议之所有条款，并已成为订房易的注册会员。用户在享用订房易会员服务的同时，同意接受订房易会员服务提供的各类信息服务。
2.订房易服务的具体内容由港捷旅提供并对其所提供之服务拥有最终解释权。
3.会员在注册成功后，将得到一个帐号和密码。您应妥善保管该帐号及密码，并对以该帐号进行的所有活动及事件负法律责任。因黑客行为或会员保管疏忽致使帐号、密码被他人非法使用的，港捷旅不承担任何责任。如您发现任何非法使用会员帐号或安全漏洞的情况，请立即与港捷旅联系。
4.会员权责
会员有权按照订房易规定的程序和要求使用订房易及港捷旅向会员提供的各项网络服务，如果会员对该服务有异议，可以与订房易联系以便得到及时解决。用户在申请使用订房易会员服务时，必须向订房易提供准确的个人资料，如个人资料有任何变动，必须及时更新。 会员须同意并接受订房易及港捷旅通过电子邮件、手机短信、电话外呼等方式向会员发送促销或其他相关商业信息（如预订确认、信息变更、资讯、活动等）。会员在订房易的网页上发布信息或者利用订房易的服务时必须符合国家的法律法规以及国际法的有关规定。对于会员上传到订房易站上信息可公开获取区域（包括但不限于BBS、评论）的任何内容，会员同意授予港捷旅享有完全的、免费的、永久性的、不可撤销的、非独家的权利，以及再许可第三方的权利，以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示此等内容（整体或部分），和/或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中。&#12288;&#12288; 
会员承诺不会通过订房易的信息发布平台（包括但不限于、BBS、评论）发布如下信息：&#12288;&#12288;(1) 反对宪法所确定的基本原则的；&#12288;&#12288;(2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；&#12288;&#12288;(3) 损害国家荣誉和利益的；&#12288;&#12288;(4) 煽动民族仇恨、民族歧视，破坏民族团结的；&#12288;&#12288;(5) 破坏国家宗教政策，宣扬邪教和封建迷信的； &#12288;&#12288;(6) 散布谣言，扰乱社会秩序，破坏社会稳定的； &#12288;&#12288;(7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；&#12288;&#12288;(8) 侮辱或者诽谤他人，侵害他人合法权益的；&#12288;&#12288;(9) 含有法律、行政法规禁止的其他内容的。会员单独为其发布在订房易上信息承担责任。会员若在订房易散布和传播违法信息，网络会员服务的系统记录有可能作为会员违法之证据。会员不得以任何方式干扰本站的服务。如果会员违反上述规定，港捷旅有权要求其改正或直接采取一切必要措施（包括但不限于更改或删除会员发布的信息、中断或终止会员使用网络的权利等）。
5.服务条款的修改 
港捷旅有权在必要时修改本服务条款而无需事先通知用户。港捷旅行使该修改权，无需对用户或第三方承担任何责任。 会员如不同意修改，可以主动选择取消会员资格；如果会员继续使用订房易服务，将被视为接受修改后的服务条款。
6.服务内容的修改或中断
鉴于网络服务的特殊性，港捷旅保留随时修改或中断其部分或全部网络服务的权利，并无需通知会员或为此对会员及任何第三方负责。
7.会员隐私保护
港捷旅尊重会员的隐私权，不会公开或泄露任何有关会员的个人资料以及会员在使用网络服务时存储在订房易的非公开内容，但以下情况除外：&#12288;&#12288;
本网站已经声明该部分内容将被公开，而用户在知道的情况下仍然提供信息；&#12288;&#12288;
国家的司法机关或政府相关部门依据法规要求获得该用户的相关信息；&#12288;&#12288; 
用户的信息可以从其它的公开渠道获得（如：公共网吧内，用户没有注销界面，而导致信息外泄）；&#12288;&#12288;
本网站谨慎地确认有必要公布用户的信息时（如该用户提供的信息误导浏览者或用户提供的信息含有欺诈性等）。 
8.中断或终止服务如发生下列任何一种情形，港捷旅有权随时中断或终止向会员提供本协议项下的网络服务，而无需对会员或任何第三方承担任何责任。会员向港捷旅提供的个人资料不真实。会员违反本协议的规则或不履行其所承担的义务。除此之外，会员可随时根据需要通知港捷旅终止向该会员提供服务，会员服务终止后，会员使用服务的权利同时终止。自会员服务终止之时起，订房易不再对该会员承担任何责任。
9.知识产权
订房易上的内容，包括但不限于文字、图形、图像、音乐、录像、标示、标识、广告、版面设计、专栏目录、链路、图表按钮、HTML编码、商标与及软件等其他材料均受著作权、商标法等相关法律的保护，并且也受适用于国际公约中有关著作权、商标权、专利权及财产所有权法律的保护。订房易的内容归属订房易或订房易供应商或客户的专有财产。未经许可，不得擅自挪作他用，否则将追究法律责任。 &#12288;&#12288;
为方便用户，订房易内设有与其它网站或网页的链接，但订房易并不对这些网站或网页进行维护，用户启用该网站或网页链接所产生的一切风险，概与订房易与港捷旅无关。 &#12288;&#12288;
订房易上的部分内容来自互联网，部分内容由于不便校对版权或内容的真实性和准确性，所以可能暂时无法确认版权或内容的真实性和准确性，由此而引起的版权问题或其他问题，请致电或电邮订房易。经核实后会立即予以删除或更改。
10.免责声明
港捷旅对任何因会员不正当或非法使用服务、在网上进行交易、或会员传送信息变动而产生的直接、间接、偶然、特殊及后续的损害不承担责任。港捷旅对任何他人的威胁性的、诽谤性的、淫秽的、令人反感的或非法的内容或行为或对他人权利的侵犯（包括知识产权）不承担责任；并对任何第三方通过服务发送或在服务中包含的任何内容不承担责任。会员明确同意其使用订房易服务所存在的风险以及使用订房易络服务产生的一切后果由其自己承担。对于因不可抗力或订房易不能控制的原因造成的网络服务中断或其它缺陷，订房易不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。	港捷旅不对所提供之网络服务做任何类型之担保，包括但不限于：(1) 网络服务一定能满足会员要求；(2) 网络服务不会中断； (3) 网络服务的及时性、安全性、准确性。	但是港捷旅对不违反规定的特定目的担保不作限制。
11.赔偿
因会员对本服务之使用而导致港捷旅遭受任何来自第三方之纠纷、诉讼及索赔要求，会员同意向港捷旅及其关联企业、职员赔偿相应损失（包括合理的律师费），并尽力使之免受损害。
12.通告
所有发给会员的通告都可以通过重要页面的公告、电子邮件以及常规信件的形式传送。
13.法律
港捷旅服务条款之效力、解释、执行均适用中华人民共和国法律。如发生争议，应提交至有管辖权之人民法院。
14.其他规定
本服务条款中的标题仅为方便而设，在解释本服务条款时应被忽略。  
                        </textarea>
                            </div>
						</div>
					</div>
					<div class="register-info-box">
						<p><i>*</i> 请填写真实信息，我们会尽快与您联系，并为您开通订房易账户。</p>
						<p><i>*</i> 提交申请后，请将贵公司执照副本电子档和联系人名片电子档发送至邮箱 op-9@cnbooking.net ， 我们将优先为您服务。</p>
						<p><i>*</i> 如有疑问请咨询 0755-8231 5186</p>
					</div>
					<div class="clear"></div>
				</div>
 
			</div>

		</div>

        <div class="home-footer">
            <div class="home-box home-footer-t">
                <div class="top">
                    <div class="left home-contact">
                        <h3>了解我们</h3>
                        <router-link to="about">关于我们</router-link>
                        <router-link to="contact">联系我们</router-link>
                        <router-link to="contact">投诉建议</router-link>
                        <router-link to="join">诚聘英才</router-link>
                    </div>
                    <div class="middle home-contact">
                        <h3>客户须知</h3>
                        <router-link to="introduction">预订须知</router-link>
                        <router-link to="introduction">协议下载</router-link>
                        <router-link to="introduction">教程下载</router-link>
                    </div>
                    <div class="right home-contact">
                        <h3>邮箱地址</h3>
                        <a href="#">国内酒店合作 chinahotel-1@cnbooking.net</a>
						<a href="#">国际酒店合作 globalhotel-33@cnbooking.net</a>
						<a href="#">OTA合作 channel-3@cnbooking.net</a>
						<a href="#">旅行社合作 chinahotel-3@cnbooking.net</a>
                    </div>
                    <div class="right-side home-contact">
                        <h3>微信二维码</h3>
                        <img src="./../../assets/img/ewm.png" alt="" />
                    </div>
                    <div class="clear"></div>
                </div>
                <div class="bottom">
                    <img src="./../../assets/img/home-footer-logo.png" alt="" />
                    <div>
                        <h4>Copyright©2013-2017,dingfangyi.com.All rights reserved.</h4>
                        <h4>
                            <a href="#" style="text-decoration: none; color: #999;">粤ICP备17131089号</a>
                            <a target="_blank" href="#" style="text-decoration: none; color: #999; float: right;">
                                <img src="./../../assets/img/ga.png" />
                                    粤公网安备 44030302000423号
                            </a>
                        </h4>
                    </div>
                </div>
            </div>
        </div>
	</div>
	</div>
</template>
<script>
	import FooterS from '../Footer-s.vue'
	import loginHeader from '../loginHeader.vue'
	export default {
        components: { FooterS,loginHeader },
        data () {
            return {
                showModal: false,
                protocol:true,
                prototcol:false,
                showText: '',
                country: {},
                province: {},
                city: {},
                codeUrl:'',
                isSubmit:false,
                isDataComplete:false,
                isInfoShwo:false,
                regData: {
                    CompanyName: '',
                    ContactMan: '',
                    Phone: '',
                    Email: '',
                    Address: '',
                    CaptchaCode: '',
                    CaptchaTrackeKey: '',
                    CaptchaToken: '',
                    CountryID: '',
                    CountryName:'',
                    ProvinceID: '',
                    ProvinceName:'',
                    CityID: '',
                    CityName:''
                
                }
            }
        },

        methods: {
            setPro(){
                this.prototcol=!this.prototcol
            },
            getCode(callback){
                let _this = this;
                _this.getRequest({
                    url: _this.Api.captcha + '?width=80&height=40'
                }).then(res => {
                    if (res) {
                      
                        this.codeUrl = 'data:image/jpg;base64,'+res.Img;
                        this.regData.CaptchaToken = res.Token;
                        this.regData.CaptchaTrackeKey = res.TraceKey;
                        if(callback){
                            callback();
                        }
                        
                    }
                });
            },
            getCountry(){
                let _this = this;
                _this.getRequest({
                    url: _this.Api.district + '?pid=0000'
                }).then(res => {
                    if (res) {
                        _this.country = res.Result;
                        this.isDataComplete=true;
                    }
                });
            },
            selectProvince(){
                let _this = this;
                this.regData.ProvinceID = '';
                
           
                for (let key in this.country){
                    if (key === this.regData.CountryID){
                        this.regData.CountryName = this.country[key];
                    }
                }

                _this.getRequest({
                    url: _this.Api.district + '?pid=' + this.regData.CountryID
                }).then(res => {
                    if (res) {
                        _this.province = res.Result;
                    }
                });
            },
            selectCity(){
                let _this = this;
                this.regData.CityID = '';

                for (let key in this.province){
                    if (key === this.regData.ProvinceID){
                        this.regData.ProvinceName = this.province[key];
                    }
                }


                _this.getRequest({
            
                    url: _this.Api.district + '?pid=' + this.regData.ProvinceID
                }).then(res => {
                    if (res) {
                        _this.city = res.Result;
                    }
                });
            },
            selectTown(){
                for (let key in this.city){
                    if (key === this.regData.CityID){
                        this.regData.CityName = this.city[key];
                    }
                }
            },
            checkData(){
           
                if (!this.regData.CompanyName) {
                    this.error({title: '提示', content: '请输入公司名称'});
                    return;
                }else if(this.regData.CompanyName.length>60){
                    this.error({title: '提示', content: '公司名称字数不能超过60个'});
                    return;
                }
                if (!this.regData.ContactMan) {
                    this.error({title: '提示', content: '请输入联系人'});
                    return;
                }else if(this.regData.ContactMan.length>10){
                    this.error({title: '提示', content: '联系人字数不能超过10个'});
                    return;
                }
                if (!this.regData.Phone) {
                    this.error({title: '提示', content: '请输入手机号码'});
                    return;
                }else{
                    var mobile = this.regData.Phone;
                    var isMobile = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(14[0-9]{1}))+\d{8})$/;
                    var isPhone = /^(?:(?:0\d{2,3})-)?(?:\d{7,8})(-(?:\d{3,}))?$/;
                    //如果为1开头则验证手机号码  
                    if (mobile.substring(0, 1) == 1) {
                        if (!isMobile.exec(mobile) && mobile.length != 11) {
                            this.error({title: '提示', content: '请输入您的正确的手机号码'});
                            return ;
                        }
                    }
                    //如果为0开头则验证固定电话号码  
                    else if (mobile.substring(0, 1) == 0) {
                        if (!isPhone.test(mobile)) {
                            this.error({title: '提示', content: '请输入您的正确的座机号码,如(0755-82217181)'});
                            return ;
                        }
                    }
                    //否则全部不通过  
                    else {
                        this.error({title: '提示', content: '请输入您的正确的联系电话'});
                        return ;
                    }
                  
                }
          
                if (!this.regData.Email||this.regData.Email.length<=0) {
                    this.error({title: '提示', content: '请输入联系邮箱'});
                    return;
                }else{
                    var email =this.regData.Email;
                    // ^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$
                    // ^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$
                    if (!email.match(/^[.A-Za-z0-9_-\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/)) {
                        this.error({title: '提示', content: '您输入的联系邮箱格式有误，请重新输入'});
                        return;
                    }
                }
                if (!this.regData.CountryName) {
                    this.error({title: '提示', content: '请输入国家/地区'});
                    return;
                }else if(this.regData.CountryName.length>50){
                    this.error({title: '提示', content: '国家/地区字数不能超过50个'});
                    return;
                } 
                if (!this.regData.CityName) {
                    this.error({title: '提示', content: '请输入城市名称'});
                    return;
                }

                if (!this.regData.Address) {
                    this.error({title: '提示', content: '请输入联系地址'});
                    return;
                }
                if (!this.regData.CaptchaCode) {
                    this.error({title: '提示', content: '请输入验证码'});
                    return;
                }
                if(!this.prototcol){
                    this.error({title: '提示', content: '请先阅读用户并同意注册协议'});
                    return;
                }
                return true;
            },
            submit: function () {
              
                let that = this;

                if(!that.checkData())return;

                that.isSubmit=true;
                that.postRequest({
                    url: that.Api.regist,
                    params: this.regData
                }).then(res => {
                    if (res.IsSuccess) {
                        that.error({title:'注册成功',content:'注册成功，您的帐号和密码我们已通过短信和邮件方式下发，请注意查收！'});
                        that.$router.push('/login');
                    }else{
                        that.error({title:'提示',content:res.Msg});
                    }
                    that.isSubmit=false;
                });
            }
        },
        mounted(){
            this.getCode(this.getCountry);
        },

	}
</script>


// WEBPACK FOOTER //
// src/components/info/register.vue